<template>
    <date-picker
        class="vh-custom-date-picker"
        mode="date"
        :masks="masks"
        v-model="selectedDate"
        @dayclick="dayClick"
        expanded>
    </date-picker>
</template>

<script>

import { DatePicker } from 'v-calendar';
import 'v-calendar/dist/style.css';

export default
{
    components:
    {
        DatePicker
    },

    props:
    {
        attributes:
        {
            type: Array,
            default: () => {
                return [];
            },
        },

        onSelectDate: Function,
    },
    
    data()
    {
        return {
            masks:
            {
                weekdays: 'WWW',
            },

            // range:
            // {
            //     start: '',
            //     end: '',
            // }
        };
    },

    computed:
    {
        selectedDate:
        {
            get()
            {
                return this.$parent.$data.selectedDate;
            },

            set (value)
            {
                this.$parent.$data.selectedDate = value;
            },
        }
    },

    methods:
    {
        dayClick(event)
        {
            this.$emit('onSelectDate', event);
        },

        dayMouseEnter()
        {
            console.log('day mouse entered...');
        },
    }
    
};
</script>
